<template>
  <body>
    <modalPIN v-show="verEnterPin"
      @cerrar="cerrarModalPin"
      @recibirPIN="recibirPIN"
    />
    <aside class="Blk-1">
      <img class="imagen" :src="usuarioVista.foto">
    </aside>
    <aside class="Blk-2">
      <article class="Form">
        <form @change="cambioForm">
          <div class="tipoUsuario">
            <h4>{{tipoUsuario}}</h4>
          </div>
          <div class="Blk-Campo">
            <p>Nombre</p>
            <input name="titulo" class="campo" ref="nombreUsuario" rows="2"
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="usuarioVista.nombre"
              spellcheck="false"
              autocomplete="off"
            >
          </div>
          <div class="Blk-Campo">
            <p>Apellidos</p>
            <input type="text" name="apellidos" class="campo"
              v-model.trim="usuarioVista.apellidos"
              :disabled = '!habBotAndCamp.hab'
              spellcheck="false"
              autocomplete="off"
            >
          </div>
           <div class="Blk-Campo">
            <p>e-Mail</p>
            <input type="text" name="email" class="campo"
              v-model.trim="usuarioVista.email"
              :disabled = true
              spellcheck="false"
              autocomplete="off"
            >
          </div>
          <div class="Blk-Campo">
            <p>País</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="usuarioVista.pais"
              :disabled = '!habBotAndCamp.hab'
              spellcheck="false"
              autocomplete="off"
            >
            </div>
          <div class="BtnImg">
            <input type="file" name="file-1" id="file-1" class="inputfile"
            @change="cargarFoto" :disabled = '!habBotAndCamp.hab'/>
            <label for="file-1" ><span class="icon-icoSubirImg"></span></label>
            <p id="eti">Cargar foto</p>
          </div>
          <div class="Blk-Campo">
            <div class="cambiar">
              <p v-if="visibleChangePassBtn" @click="cambiarPass">{{txtBtnChPass}}</p>
              <p v-if="visibleChangeMailBtn" @click="cambiarMail">{{txtBtnChMail}}</p>
              <p v-if="visibleEliCuentaBtn" @click="eliminarCuenta">{{txtBtnXcuenta}}</p>
            </div>
          </div>
          <div v-if="visibleChangePass">
            <div class="Blk-Campo">
              <p>Contraseña actual</p>
              <div class="input-container">
                <input :type="modoPass0" name="currentPass" class="campo-corto"
                  v-model.trim="currentPass"
                  :disabled = false
                  spellcheck="false"
                  autocomplete="off"
                  autofocus>
                <span class="ojo" @click="verPass0">👁</span>
              </div>
            </div>
            <!-- @blur="veriPass" -->
            <div class="Blk-Campo">
              <p>Contraseña nueva</p>
              <div class="input-container">
                <input :type="modoPass1" name="newPass" class="campo-corto"
                  @blur="checkPass (newPass1)"
                  v-model.trim="newPass1"
                  :disabled = habilitaNewPass
                  spellcheck="false"
                  autocomplete="off">
                <span class="ojo" @click="verPass1">👁</span>
              </div>
            </div>
            <div class="Blk-Campo">
              <p>Contraseña nueva (Rep.)</p>
              <div class="input-container">
                <input :type="modoPass2" name="newPass2" class="campo-corto"
                  v-model.trim="newPass2"
                  :disabled = habilitaNewPass
                  spellcheck="false"
                  autocomplete="off">
                <span class="ojo" @click="verPass2">👁</span>
              </div>
            </div>
            <div class="Blk-Campo">
              <div class="enviar">
                <p @click="enviarPass">ENVIAR</p>
              </div>
            </div>
          </div>
          <div v-show="visibleChangeMail">
            <div class="Blk-Campo">
              <p>Nuevo e-Mail</p>
              <input type="mail" name="newMail" class="campo"
                v-model.trim="newMail"
                :disabled = false
                spellcheck="false"
                autocomplete="off">
            </div>
            <p class="msg" v-show="verMsgMail"> Se ha enviado un PIN a la nueva dirección </p>
            <div class="Blk-Campo">
              <div class="enviar">
                <p @click="enviarMail">ENVIAR</p>
              </div>
            </div>
          </div>
          <div v-show="visibleEliCuenta">
            <p class="msg"> Para eliminar la cuenta deberás suministrar nuevamente la contraseña</p>
            <div class="Blk-Campo">
              <p>Contraseña</p>
              <input type="mail" name="eliPass" class="campo-corto"
                v-model.trim="eliPass"
                :disabled = false
                spellcheck="false"
                autocomplete="off">
            </div>
            <div class="Blk-Campo">
              <div class="enviar">
                <p @click="enviarEliPass">ENVIAR</p>
              </div>
            </div>
          </div>
          <img class="imagen2" :src="usuarioVista.foto">
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
        :botones=[0,1,0,1]
        :desacEdit="!habBotAndCamp.actEdi"
        :desacSave="!habBotAndCamp.actSav"
        @editar="editar"
        @save="save"
        />
      </aside>
    </aside>
  </body>
</template>

<script>
import axios from 'axios'
import BotonesCRUD from '@/components/BotonesCRUD.vue'
import { mapState } from 'vuex'
import modalPIN from '@/components/modalPIN.vue'
export default {
  name: 'FormDatPerso',
  components: { BotonesCRUD, modalPIN },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.usuarioVista = this.usuarioEnSesion // Trae datos del usuario de la tienda 'store'
    this.activaModo('S')
    this.elUsuarioEs()
    if (!this.usuarioVista.foto) { this.usuarioVista.foto = this.defaultImg }
  },
  data () {
    return {
      usuarioSel: [],
      usuarioSelBkUp: [],
      tipoUsuario: '',
      usuarioVista: {},
      usuarioVistaBkUp: {},
      defaultImg: require('@/assets/silueta.png'),
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        hab: false
      },
      IsModoSalirEdi: false,
      visibleChangePass: false,
      visibleChangeMail: false,
      visibleEliCuenta: false,
      visibleChangePassBtn: true,
      visibleChangeMailBtn: true,
      visibleEliCuentaBtn: true,
      txtBtnChPass: 'Cambiar contraseña',
      txtBtnChMail: 'Cambiar e-Mail',
      txtBtnXcuenta: 'Eliminar cuenta',
      currentPass: '',
      newPass1: '',
      newPass2: '',
      newMail: '',
      habilitaNewPass: false,
      URLbase: '',
      verEnterPin: false,
      pin: '',
      eliPass: '',
      verMsgMail: false,
      modoPass0: 'password',
      modoPass1: 'password',
      modoPass2: 'password'
    }
  },
  methods: {
    editar () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      // Si es modo edición, hace copia de los datos actuales por si se cancela
      if (this.IsModoSalirEdi) {
        this.usuarioVistaBkUp = JSON.parse(JSON.stringify(this.usuarioVista))
        this.usuarioSelBkUp = this.usuarioSel
        this.activaModo('EDI')
      } else {
        // Si se cancela, restura los valores previos
        this.usuarioVista = JSON.parse(JSON.stringify(this.usuarioVistaBkUp))
        this.usuarioSel = this.usuarioSelBkUp
        this.activaModo('S')
        document.getElementById('file-1').value = ''
      }
    },
    cambioForm () {
      if (this.IsModoSalirMas) {
        this.activaModo('MASs')
      }
      if (this.IsModoSalirEdi) {
        this.activaModo('EDIs')
      }
    },
    save () {
      try {
        const url = `${this.URLbase}/users/saveUserData`
        const userData = this.usuarioVista
        axios.post(url, userData)
          .then(result => {
            switch (result.data) {
              case 'error':
                this.alertJoa('Error en la actualización, reinicia la aplicación e intenta otra vez', 'E')
                break
              case 'success':
                this.alertJoa('Datos actualizados con éxito!', 'S')
                break
            }
          })
          .catch(error => console.log(error))
        this.$store.commit('doLogin', this.usuarioVista)
      } catch (error) {
        alert(error)
      }
      this.activaModo('S')
    },
    async cargarFoto (event) {
      // Se abre una ventana para seleccionar un archivo de la máquina del usuario
      // y se asigna el archivo a fotoUser
      let fotoUser = event.target.files[0]
      fotoUser = await this.reducirTamanoImagen(fotoUser)
      const reader = new FileReader()
      reader.readAsDataURL(fotoUser)
      reader.onload = e => { this.usuarioVista.foto = e.target.result }
    },
    async reducirTamanoImagen (fotoUser) {
      const tamanoMaximo = 250000 // 250 KB
      const calidadMaxima = 0.7 // Calidad máxima para la compresión JPEG (entre 0 y 1)
      if (fotoUser.size <= tamanoMaximo) { // Verifica el tamaño de la imagen
        return fotoUser
      }
      const img = new Image() // Crear un objeto de tipo imagen
      // Crear una promesa para cargar la imagen
      const cargarImagen = new Promise((resolve, reject) => {
        img.onload = () => resolve()
        img.onerror = () => reject(new Error('No se pudo cargar la imagen'))
        img.src = URL.createObjectURL(fotoUser)
      })
      await cargarImagen // Espera a que se cargue la imagen
      const canvas = document.createElement('canvas') // Crea un canvas para manipular la imagen
      const ctx = canvas.getContext('2d')
      // Calcula nuevas dimensiones de la imagen manteniendo la proporción
      let nuevoAncho = img.width
      let nuevoAlto = img.height
      const proporcion = img.width / img.height
      const tamanoDeseado = Math.sqrt(tamanoMaximo)
      if (nuevoAncho > nuevoAlto && nuevoAncho > tamanoDeseado) {
        nuevoAncho = tamanoDeseado
        nuevoAlto = nuevoAncho / proporcion
      } else if (nuevoAlto > nuevoAncho && nuevoAlto > tamanoDeseado) {
        nuevoAlto = tamanoDeseado
        nuevoAncho = nuevoAlto * proporcion
      }
      canvas.width = nuevoAncho // Redimensiona el canvas
      canvas.height = nuevoAlto
      ctx.drawImage(img, 0, 0, nuevoAncho, nuevoAlto) // Dibuja la imagen en el canvas
      return new Promise(resolve => {
        canvas.toBlob(blob => { // Convierte el canvas a un Blob
          resolve(blob)
        }, 'image/jpeg', calidadMaxima) // con formato JPEG y calidad especificada
      })
    },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          break
        case 'S':
          this.confModo = [1, 1, 1, 0, 0]
          break
        case 'MAS':
          this.confModo = [1, 0, 0, 0, 1]
          break
        case 'MASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'EDI':
          this.confModo = [0, 1, 0, 0, 1]
          break
        case 'EDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    },
    elUsuarioEs () {
      switch (this.usuarioEnSesion.tipoUsuario) {
        case 0 :
          this.tipoUsuario = 'Usuario registrado'
          break
        case 1 :
          this.tipoUsuario = 'Miembro de la Sociedad Venezolana de Espeleología'
          break
        case 2 :
          this.tipoUsuario = 'Miembro de la SVE y bibliotecario'
          break
        case 3 :
          this.tipoUsuario = 'Miembro de la SVE y administrador'
          break
      }
    },
    cambiarPass () {
      if (this.txtBtnChPass === 'Cambiar contraseña') {
        this.visibleChangePass = true
        this.visibleChangeMailBtn = false
        this.visibleEliCuentaBtn = false
        this.currentPass = ''
        this.newPass1 = ''
        this.newPass2 = ''
        this.txtBtnChPass = 'Cancelar'
        this.activaModo('INI') // No se puede hacer otra cosa que Cancelar o Cambiar Pass
      } else {
        this.visibleChangePass = false
        this.visibleChangeMailBtn = true
        this.visibleEliCuentaBtn = true
        this.txtBtnChPass = 'Cambiar contraseña'
        this.activaModo('S')
      }
    },
    verPass0 () {
      this.modoPass0 = 'text'
      setTimeout(() => { this.modoPass0 = 'password' }, 2500)
    },
    verPass1 () {
      this.modoPass1 = 'text'
      setTimeout(() => { this.modoPass1 = 'password' }, 2500)
    },
    verPass2 () {
      this.modoPass2 = 'text'
      setTimeout(() => { this.modoPass2 = 'password' }, 2500)
    },
    eliminarCuenta () {
      if (this.txtBtnXcuenta === 'Eliminar cuenta') {
        this.visibleEliCuenta = true
        this.visibleChangeMailBtn = false
        this.visibleChangePassBtn = false
        this.currentPass = ''
        this.txtBtnXcuenta = 'Cancelar'
        this.activaModo('INI') // No se puede hacer otra cosa que Cancelar o Cambiar Pass
      } else {
        this.visibleEliCuenta = false
        this.visibleChangePassBtn = true
        this.visibleChangeMailBtn = true
        this.txtBtnXcuenta = 'Eliminar cuenta'
        this.activaModo('S')
        this.eliPass = ''
      }
    },
    cambiarMail () {
      if (this.txtBtnChMail === 'Cambiar e-Mail') {
        this.visibleChangePassBtn = false
        this.visibleEliCuentaBtn = false
        this.txtBtnChMail = 'Cancelar'
        this.visibleChangeMail = true
        this.newMail = ''
        this.activaModo('INI') // No se puede hacer otra cosa que Cancelar o Cambiar Mail
      } else {
        this.visibleChangeMail = false
        this.visibleChangePassBtn = true
        this.visibleEliCuentaBtn = true
        this.verMsgMail = false
        this.txtBtnChMail = 'Cambiar e-Mail'
        this.activaModo('S')
      }
    },
    enviarMail () {
      if (this.formatoCorrecto(this.newMail)) {
        this.verMsgMail = true
        const url = `${this.URLbase}/send-mail`
        axios.post(url, { email: this.newMail, caso: 'nuevoMail' })
          .then(result => {
            if (result.data === 'success') {
              this.verEnterPin = true
            }
          })
      } else {
        this.alertJoa('El formato del nuevo e-Mail no es correcto', 'W')
      }
    },
    cambiarMailFin () {
      try {
        const url = `${this.URLbase}/users/newMail`
        const cambioMail = { pin: this.pin, mail: this.newMail, _id: this.usuarioVista._id }
        axios.post(url, cambioMail)
          .then(result => {
            console.log(result.data)
            switch (result.data) {
              case 'fail':
                this.alertJoa('Error de servidor, reinicia la aplicación e intenta otra vez', 'E')
                this.cambiarMail()
                break
              case 'success':
                this.alertJoa('Cambio realizado con éxito. Ingresa desde ahora con el nuevo email.', 'S')
                this.usuarioVista.email = this.newMail
                this.cambiarMail()
                break
              case 'failPIN':
                this.alertJoa('El pin no es correcto, intenta otra vez', 'W')
                this.pin = ''
                break
            }
          })
          .catch(error => console.log(error))
      } catch (error) {
        console.log(error)
      }
    },
    enviarPass () {
      if (this.newPass1 === this.newPass2) {
        try {
          const url = `${this.URLbase}/users/newPass2`
          const datReg = {
            id: this.usuarioVista._id, // sería buena cambiarlo por el _Id por seguridad
            newPass: this.newPass1,
            currentPass: this.currentPass
          }
          axios.post(url, datReg)
            .then(result => {
              switch (result.data) {
                case 'error':
                  this.alertJoa('Error en la actualización, reinicia la aplicación e intenta otra vez', 'E')
                  break
                case 'success':
                  this.visibleChangePass = false
                  this.visibleChangeMailBtn = true
                  this.visibleEliCuentaBtn = true
                  this.txtBtnChPass = 'Cambiar contraseña'
                  this.activaModo('S')
                  this.alertJoa('Contraseña cambiada con éxito. En el próximo ingreso, usa la nueva contraseña.', 'S')
                  break
                case 'passFail':
                  this.alertJoa('La contraseña actual no es correcta', 'W')
                  break
              }
            })
            .catch(error => console.log(error))
        } catch (error) {
          console.log(error)
        }
      } else {
        this.alertJoa('Las contraseñas no son iguales', 'W')
      }
    },
    async enviarEliPass () {
      if (!this.checkPassword(this.eliPass)) {
        this.alertJoa('La contraseña no es correcta', 'W')
      } else {
        const response = await this.$root.alertJoa(
          'Estás a punto de eliminar tu cuenta. Se borrarán todos tus datos. Esta acción no puede revertirse ¿Quieres continuar?',
          'W', 'C'
        )
        if (response === 'borrar') {
          const url = `${this.URLbase}/users/eliminarCuenta`
          const cuenta = { _id: this.usuarioVista._id, pass: this.eliPass }
          axios.post(url, cuenta, {
            headers: {
              authorization: this.usuarioVista.tokenUser
            }
          })
            .then(result => {
              if (result.data === 'passFail') {
                this.alertJoa('La contraseña suministrada no es correcta, verifica e intenta otra vez.', 'E')
                this.eliminarCuenta() // esto es como pulsar el botón cancelar, ver la función
              } else if (result.status === 200) {
                this.$store.commit('doLogout')
                this.$router.push('/')
              } else {
                this.alertJoa('Algo ha salido mal, reinicia la aplicación e intenta de nuevo', 'W')
                this.eliminarCuenta() // esto es como pulsar el botón cancelar, ver la función
              }
            })
        } else {
          this.eliminarCuenta() // esto es como pulsar el botón cancelar, ver la función
        }
      }
    },
    checkPass (password) {
      if (password === this.currentPass) {
        this.alertJoa('La nueva contraseña debe ser distinta a la actual', 'W')
        return
      }
      if (this.checkPassword(password)) {
        this.$refs.pass2.focus()
      } else {
        this.alertJoa('La contraseña debe contener (como mínimo) un número, una minúscula, una mayúscula y seis caracteres', 'W')
        this.$refs.pass1.focus()
      }
    },
    formatoCorrecto (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    checkPassword (pass) {
      // mínimo un número, una minúscula y una mayúscula
      // mínimo seis caracteres
      var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/
      return re.test(pass)
    },
    cerrarModalPin () {
      this.verEnterPin = false
    },
    recibirPIN (pin) {
      this.pin = pin
      this.cambiarMailFin()
    }
  },

  computed: {
    ...mapState(['usuarioEnSesion']),
    sesion () {
      return (this.usuarioEnSesion.nombre === undefined)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.imagen{
  margin-top: 75px;
  width:80%;
  justify-self: center;
  box-shadow: rgb(53, 52, 52) 5px 5px 7px;
}
.imagen2{
  display:none;
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
article.Form {
  /* color: darkslategray; */
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
  position: sticky; /* no funciona */
}
.formInd{
  margin-top: 55px;
}
.formIndTel{
  display:none;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.Blk-Campo #changePass{
  flex-direction: column;
}
.msg{
  color: rgb(192, 3, 3);
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: rgb(250, 189, 132);
}
.campo-corto{
  height: auto;
  min-height: 26px;
  max-width: 100%;
  min-width: 70px;
  padding-left: 8px;
  background-color: rgb(246, 245, 230);
  border: solid 0.5px rgb(199, 191, 188);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.tipoUsuario{
  text-align: left;
  color: var(--tx-cam);
  padding-left: 18px;
  padding-bottom: 7px;
}
.botAut{
  height: auto;
  min-height: 26px;
  width: 26px;
  font-size: 18px;
}
#titReg{
  font-weight: bold;
}

.BtnImg{
  display:flex;
  align-items: center;
}
.BtnImg p{
  color:black;
  font-size: 13px;
  padding-top: 4px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: relative;
  /* z-index: -1; *****/
  visibility:hidden;
}
/*Esta clase da el formato al boton y la etiqueta */
.inputfile + label {
  /* width: 63.5%;  */
  cursor: pointer;
  padding: 5px;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 6px;
  color: black;
  font-size: 16px;
}
.inputfile + label:hover {
  transform: scale(1.08);
  /* background-color: rgb(192, 205, 206); */
  /* .inputfile:focus + label, .inputfile.has-focus + label,*/
}
.inputfile + label:disabled {
  transform: scale(1); /* No funciona*/
  color: rgb(103, 103, 103); /* No funciona*/
}
.inputfile:disabled + label {
  color: #8fa3ad; /* No funciona*/
}
.icon-icoSubirImg {
  color: var(--az-ico);
  font-size: 1.45em;
  padding-left: 9px;
  padding-right: 9px;
}
.icon-icoSubirImg:disabled {
  color: rgb(103, 103, 103); /* No funciona*/
}
.cambiar, .enviar{
  display: flex;
  width: 200px;
  margin-left: 14px;
}
.Blk-Campo .cambiar p{
  background-color: var(--az-me-tr07);
  margin: 5px;
  color:white;
  text-align: center;
  width: 200px;
  padding: 4%;
  padding-top: 4%;
  padding-bottom: 4%;
  line-height: 120%;
  cursor:pointer;
}
.Blk-Campo .enviar p{
  /* background-color: rgba(49, 108, 127, 0.8);*/
  border: solid 2px var(--az-me-tr07);
  border-radius: 4px;
  margin: 5px;
  color:var(--az-me-tr07);
  text-align: center;
  width: 200px;
  padding: 2%;
  padding-top: 3%;
  padding-bottom: 3%;
  line-height: 120%;
  cursor:pointer;
}
.input-container {
  /* position: relative; */
  display: flex;
  /* align-items: center; */
}
.ojo{
  color:rgba(10, 90, 140, 0.5);
  font-size: 20px;
  padding-left: 10px;
  cursor: pointer;
}

@media screen and (max-width: 600px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  .Form {
    padding-top: 10px;
    overflow: scroll;
  }
  .Blk-Campo {
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
  }
  .Blk-Campo p{
    max-width: 190px;
  }
  .campo{
    /* width: 100% no funciona, el ancho se controla con align-items: strech en .Blk-Campo*/
    margin: 0 2% 0 2%;
  }
  .campo-corto{
    max-width: 100%;
    margin: 0 2% 0 2%;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  #nombreSeparata{
    max-width: 96%;
  }
  .Btns {
    padding: 0 2.5% 2% 2.5%;
  }
  .formInd{
    display: none;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  .botonesAut{
    align-self: flex-end;
    margin-right: 2.5%;
  }
  .imagen2{
    display:inline-flex;
    width: 55%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }
  .input-container {
    position: relative;
    display: flex;
    /* align-items: center; */
  }
  .ojo{
    position: absolute;
    /* font-size: 20px; */
    top: -0.1rem;
    right: 1.2rem;
  }
}
@media screen and (max-width: 375px){
  .Blk-Campo {
    margin: 2px 0 0;
  }
  .Blk-Campo p{
    max-width: 90px;
  }
  .cambiar, .enviar{
    display: flex;
    width: 130px;
    margin-left: 14px;
}
}

</style>
